import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class Category {

    private _categoryId: number;
    private _parentId: number | null;
    private _name: string;
    private _status: string;
    private _sortNumber: number;

    public constructor(categoryId: number, parentId: number | null, name: string, status: string, sortNumber: number) {

        this._categoryId = categoryId;
        this._parentId = parentId;
        this._name = name;
        this._status = status;
        this._sortNumber = sortNumber;
    }

    public get categoryId(): number {
        return this._categoryId;
    }

    public set categoryId(value: number) {
        this._categoryId = value;
    }

    public get parentId(): number | null {
        return this._parentId;
    }

    public set parentId(value: number | null) {
        this._parentId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Category | null {

        const categoryId: number | null = safeParseNullDefault<number>(json?.categoryId, 0);
        const parentId: number | null = safeParseNullDefault<number>(json?.parentId, 0);
        const name: string = safeParse<string>(json?.name, '');
        const status: string = safeParse<string>(json?.status, '');
        const sortNumber: number = safeParse<number>(json?.sortNumber, 0);
        
        if (categoryId === null) {
            return null;
        }

        return new Category(categoryId, parentId, name, status, sortNumber);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): Category | null {

        const categoryId: number | null = safeParseNullDefault<number>(object?._categoryId, 0);
        const parentId: number | null = safeParseNullDefault<number>(object?._parentId, 0);
        const name: string = safeParse<string>(object?._name, '');
        const status: string = safeParse<string>(object?._status, '');
        const sortNumber: number = safeParse<number>(object?._sortNumber, 0);
        
        if (categoryId === null) {
            return null;
        }

        return new Category(categoryId, parentId, name, status, sortNumber);
    }
}

export default Category;